import { useTranslate } from "src/i18n";

export const useProductInfoTranslate = () => {
  const { t } = useTranslate();

  return {
    cost: t("product_info.cost", "Цена"),
    delivery: t("product_info.delivery", "Сроки доставки"),
    select_platform_hint: t(
      "product_info.select_platform_hint",
      "Выберите платформу выше, чтобы загрузить цену",
    ),
  };
};
